import { defineType } from "sanity";
import textTruncate from "../../utils/textTruncate";

export default defineType({
  name: "introSection",
  title: "Intro Section",
  options: {
    collapsible: true,
    collapsed: true
  },
  type: "object",
  fields: [
    {
      name: "leadIn",
      title: "Lead In",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required()
    }
  ],
  preview: {
    select: {
      leadIn: "leadIn"
    },
    prepare(selection) {
      const { leadIn } = selection;
      //TODO: fix old truncate method textTruncate(leadin.en)
      return {
        title: textTruncate(leadIn)
      };
    }
  }
});
